// @ts-check

if (!customElements.get("ff-facets")) {
  class FfFacets extends HTMLElement {
    ffNewUrl = new URL(window.location.href);

    constructor() {
      super();

      this.ffRegisterFilterListeners();
      this.ffUpdateProductCount();
      
      // También actualizar en load
      window.addEventListener('load', () => this.ffUpdateProductCount());
    }

    /**
     * Actualiza el contador de productos mostrados
     */
    ffUpdateProductCount = () => {
      requestAnimationFrame(() => {
        // Buscar contador por id del bloque estático
        const counter = document.querySelector('[id*="ff-products-count"] .ff-snippet-text');
        if (!counter) return;
        
        // Buscar el grid de productos
        const targetGrid = document.querySelector('.ff-product-grid-container-js');
        if (!targetGrid) return;
        
        const mobileBreakpoint = parseInt(this.dataset.ffMobileBreakpoint || '768');
        const isMobile = window.innerWidth <= mobileBreakpoint;
        const selector = isMobile 
          ? '.ff-card-product:not(.ff-d-none--mb)'
          : '.ff-card-product';
        
        const visibleCount = targetGrid.querySelectorAll(selector).length;
        // Usar el total filtrado en lugar del total de la colección
        const totalCount = this.dataset.ffFilteredCount || this.dataset.ffTotalCount || '0';
        const translatedText = this.dataset.ffTranslatedText || '';
        
        if (visibleCount > 0 && translatedText) {
          const text = translatedText
            .replace('[%RESULTS_COUNT%]', `<b>${visibleCount}</b>`)
            .replace('[%PRODUCTS_TOTAL%]', `<b>${totalCount}</b>`);
          counter.innerHTML = `<p>${text}</p>`;
        }
      });
    };

    ffRegisterFilterListeners = () => {
        document.querySelectorAll("[data-ff-sortby-value]").forEach(sortby => {
          sortby.addEventListener("change", () => {
            // @ts-ignore
            this.ffNewUrl.searchParams.set("sort_by", sortby.value);
            // Auto-apply sort on change
            this.ffApplyUrl(this.ffNewUrl);
          });
        })

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      const filters = this.querySelectorAll("[data-ff-filter-value]");
      filters.forEach((filter) => {
        filter.addEventListener("change", () => {
          const { ffFilterValue, ffFilterName } = filter.dataset;

          if (!ffFilterValue || !ffFilterName) {
            throw new Error("Filter is missing name or value in dataset");
          }
          if (this.ffNewUrl.searchParams.has(ffFilterName, ffFilterValue)) {
            this.ffNewUrl.searchParams.delete(ffFilterName, ffFilterValue);
          } else {
            this.ffNewUrl.searchParams.append(ffFilterName, ffFilterValue);
          }
          
          // Auto-apply filters on change
          this.ffApplyUrl(this.ffNewUrl);
        });
      });

      /**
       * @type {NodeListOf<HTMLInputElement>}
       */
      const priceFilters = this.querySelectorAll("[data-ff-filter-price-name]");
      priceFilters.forEach((priceFilter) => {
        priceFilter.addEventListener("change", () => {
          this.adjustToValidValues(priceFilter);
          this.setMinAndMaxValues(priceFilters);
          const { ffFilterPriceName } = priceFilter.dataset;

          this.ffNewUrl.searchParams.set(ffFilterPriceName, priceFilter.value);
          // Auto-apply price filters on change
          this.ffApplyUrl(this.ffNewUrl);
        });

        priceFilter.addEventListener("keydown", (event) => {
          if (event.metaKey) return;

          const pattern =
            /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
          if (!event.key.match(pattern)) event.preventDefault();
        });

        const { ffFilterPriceName } = priceFilter.dataset;

        this.ffNewUrl.searchParams.set(ffFilterPriceName, priceFilter.value);
      });


    };

    /**
     *
     * @param {NodeListOf<HTMLInputElement>} inputs
     */
    setMinAndMaxValues = (inputs) => {
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("data-min", "0");
      if (maxInput.value === "")
        minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
    };

    /**
     *
     * @param {HTMLInputElement} input
     */
    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("data-min"));
      const max = Number(input.getAttribute("data-max"));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }

    /**
     *
     * @param {URL} url
     */
    ffApplyUrl = async (url) => {
      const productGrid = document.querySelector(".ff-product-grid-js");
      productGrid.classList.add("ff-shimmer");
    
      try {
        // Remove pagination parameter to reset to page 1 when filters are applied
        url.searchParams.delete('page');
    
        const html = await fetch(url)
          .then((res) => res.text())
          .then((text) => new DOMParser().parseFromString(text, "text/html"));
    
        // Find all product grid containers in both DOMs
        const newGrids = html.querySelector(".ff-product-grid-js").querySelectorAll(".ff-product-grid-container-js");
        const currentGrids = productGrid.querySelectorAll(".ff-product-grid-container-js");
    
        // Replace each existing grid with the new one (matched by index)
        newGrids.forEach((newGrid, index) => {
          const currentGrid = currentGrids[index];
          if (currentGrid) {
            currentGrid.replaceWith(newGrid);
          } else {
            productGrid.appendChild(newGrid);
          }
        });
    
        // Replace filters, counts, etc.
        const newDrawerContent = html.querySelector(".ff-facets-updatable--js");
        if (newDrawerContent) {
          this.querySelector(".ff-facets-updatable--js")?.replaceWith(newDrawerContent);
        }
    
        const newCount = html.getElementById("ff-facets-results-count");
        if (newCount) {
          document.getElementById("ff-facets-results-count")?.replaceWith(newCount);
        }

        // Actualizar los data attributes del contador (total y filtrado)
        const newFacets = html.getElementById("ff-facets");
        if (newFacets) {
          this.dataset.ffTotalCount = newFacets.dataset.ffTotalCount;
          this.dataset.ffFilteredCount = newFacets.dataset.ffFilteredCount;
        }

        // Update pagination
        const newPagination = html.querySelector(".ff-pagination-actions");
        const currentPagination = document.querySelector(".ff-pagination-actions");
        
        if (newPagination && currentPagination) {
          // Replace existing pagination with new one
          currentPagination.replaceWith(newPagination);
        } else if (!newPagination && currentPagination) {
          // Remove pagination if it no longer exists (only one page of results)
          currentPagination.remove();
        } else if (newPagination && !currentPagination) {
          // Add pagination if it didn't exist before but now it does
          const collectionLayout = document.querySelector(".ff-theme-block_collection-tabs_layout");
          if (collectionLayout) {
            collectionLayout.appendChild(newPagination);
          }
        }
    
        // Push new state
        history.pushState(url.search, "", url.href);
    
        this.ffRegisterFilterListeners();

        // Actualizar el contador de productos
        this.ffUpdateProductCount();
      } catch (error) {
        console.error("Failed to update product grids:", error);
      } finally {
        requestAnimationFrame(() => {
          productGrid.classList.remove("ff-shimmer");
        });
      }
    };
    
  }

  customElements.define("ff-facets", FfFacets);
}
